import * as React from 'react';

import type { InlineEmojiData } from '@gitbook/doc-core';
import type { InlineProps } from '@gitbook/slate-react';
import { Emoji, EmojiPicker, Paper, usePopoverClose } from '@gitbook/spine-react';
import { useEventCallback } from '@gitbook/util-react-hooks';

import { VoidInlineWithPopover } from '../common';

/**
 * Renderer for an emoji inline node.
 */
export function InlineEmoji(props: InlineProps): React.ReactElement {
    const { node } = props;
    const { code } = node.data.toFrozenObject() as InlineEmojiData;

    return (
        <VoidInlineWithPopover
            {...props}
            renderSpan={() => <Emoji code={code} size={null} />}
            popover={<InlineEmojiPopover {...props} />}
        />
    );
}

function InlineEmojiPopover(props: InlineProps): React.ReactElement {
    const { node, editor } = props;

    const [query, setQuery] = React.useState('');
    const closePopover = usePopoverClose();

    const onPick = useEventCallback((value: string) => {
        editor.change((change) => {
            change.setNodeByKey(node.key, {
                data: {
                    code: value,
                },
            });
        });
        closePopover();
    });

    return (
        <Paper className="flex flex-col">
            <EmojiPicker onPick={(emoji) => onPick(emoji)} query={query} onChangeQuery={setQuery} />
        </Paper>
    );
}
